<template>
  <article class="login">
    <section class="login__sect-left">
      <img src='./../../assets/img/logo_fusesecurity.svg' class="login__sect-left__img">
    </section>
    <section class="login__sect-right">
        <div class="login__sect-right__form">
            <h2>Ingreso</h2>
            <div class="login__buttons">
              <div 
                class="login__buttons_rol"
                :class="{'active_rol': rol == 'admin'}"
                @click="rol = 'admin'"
              >
                <p>
                  Administrador
                </p>
              </div>
              <div 
                class="login__buttons_rol"
                :class="{'active_rol': rol == 'coord'}"
                @click="rol = 'coord'"
              >
                <p>
                  Coordinador
                </p>
              </div>
            </div>
            <div :class="{'active' : isInError}" class="login_input">
              <label>
                Ingrese su correo electrónico
              </label>
              <input type="email" 
                    required="required" 
                    autocomplete="email" 
                    @input="checkMailAcepted" 
                    placeholder="Correo electrónico"
                    v-model="user.email">
            </div>

            <div :class="{'active' : isInErrorPass}" class="login_input">
              <label>
                Ingrese su contraseña
              </label>
              <input v-model="user.password" 
                      type="password"
                      @input="checkPass"
                      required="required"  
                      placeholder="Contraseña">
            </div >
            <h5 v-show="isInError" class="login__sect-right__form--error">Correo electrónico incorrecto*</h5>
            <h5 v-show="!isInError" class=""></h5>
            <h5 v-show="isInErrorPass" class="login__sect-right__form--error">Campo de contraseña vacio*</h5>
            <h5 v-show="!isInErrorPass" class=""></h5>
            <h5  class="login__sect-right__form--error">{{errorMessage}}</h5>
            <div class="submit"> 
              <button :class="{'active' : isInError, 'ready': !isInError && !isEmpty}" @click="access" class="submit_button">
                Ingresar
              </button>
              <!-- <div class="pass_recover">
                Olvidé mi contraseña
              </div> -->
            </div>
            
        </div>
    </section>
  </article>
</template>
<script>
export default{
  data(){
    return {
      valid:true,
      user:{
        email:'',
        password:''
      },
      rol: 'admin',
      isInError:false,
      isInErrorPass:false,
      errorMessage: '',
      isEmpty:true,
    };
  },
  methods: {
    checkMailAcepted(){
      //Verifica que el correo sea correcto y no vacío.
      this.errorMessage='';
      if(this.user.email!='' && this.user.password!=''){
        this.isEmpty = false;
      }else{
        this.isEmpty = true;
      }
      if(!this.isMailAcepted){
          this.isInError=true;
      }
      else{
        this.isInError=false
        
      }
        
    },
    checkPass(){

      //Verifica que la contraseña sea correcta
      this.errorMessage = '';
      if(this.user.email && this.user.password){
        this.isEmpty = false;
      }else{
        this.isEmpty = true;
      }
      if(!this.user.password){
        this.isInErrorPass = true;
      }else{
        this.isInErrorPass = false;

      }
    },
    access(){
      
      if(this.user.email =="" ){
        this.isInError = true;
      }
      if(this.user.password ==""){
        this.isInErrorPass = true;
      }else{
        this.isInErrorPass = false;
  
      }
      
      

      if(!this.isInError && !this.isInErrorPass){

        const customActions={
          create: {method: 'POST'}                   
        };
        
        
        // Validar sí el usuario es administrador o coordinador
        if (this.rol == 'admin') {
          this.resource= this.$resource('administrators/users/sign_in',{},customActions);
        }else{
          this.resource= this.$resource('coordinators/users/sign_in',{},customActions);
        }
        //Petición que redirecciona  a la vista guardas.
        this.resource.create({
          "user": {"email": this.user.email, "encrypted_password": this.user.password},
          request: 'platform'
        })
        .then(function(data){
          localStorage.setItem('user', JSON.stringify(data.body.user));
          localStorage.setItem('crypto', data.body.token);
          localStorage.setItem('isAdmin', data.body.isAdmin);
          localStorage.setItem('rol', data.body.rol);
          this.updateRol(data.body.rol);
          this.updateUserInfo(data.body.user);
          if(data.body.change){            
            this.$router.push({ name: 'NewPassword' });
          }else{
            this.$router.push({ name: 'Guards' });
          }
          
        }).catch(function(err){
          console.log('ERROR')
          console.log(err);
          this.errorMessage = err.body.errors;   
        });

      }
    }
  },
  computed:{
      isMailAcepted(){
        //Verifica si el email está en un formato correcto.
          var regex = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
          return regex.test(this.user.email);
      }
  },
  created(){

      
      
      if(localStorage.getItem('message')){
        this.errorMessage=localStorage.getItem('message');
        localStorage.setItem('message','');
      }
      
  }
}
</script>


// WEBPACK FOOTER //
// src/components/authentication/Login.vue